import { flatMap } from "lodash";
import request from "../utils/request";

/**
 * 获取职业下相关画板
 * @param {{
 * params: {jobId:number},
 * query: {limit: number|30}
 * }}
 * @returns {Promise<{boards: Object[]}>}>}
 */
export async function getJobBoards({ jobId, query = { limit: 30 } }) {
  return request({
    url: `/jobs/${jobId}/boards`,
    query,
  });
}

/**
 * 获取多个领域下职业下相关画板
 * @param {{
 * params: {jobId:number},
 * query: {limit: number|30}
 * }}
 * @returns {Promise<{boards: Object[]}>}>}
 */
export async function getJobsBoards({ jobIds, query = { limit: 30 } }) {
  const results = await Promise.all(
    jobIds.map((id) => getJobBoards({ jobId: id, query }))
  );
  const boards = flatMap(results, (res) => res.boards);
  const err = results.find((res) => res.err)?.err;
  return {
    boards,
    err,
  };
}
/**
 * 个人设置，设置职业
 * @param {string} job 职业
 * @returns
 */
export async function setJob(id, name) {
  return request({
    method: "post",
    url: "/settings",
    data: {
      profile: {
        job: name,
      },
      job_id: id,
    },
  });
}

/**
 * 获取引导页相关信息
 */
export async function getGuideInfo() {
  return request({
    method: "get",
    url: "/guide_user",
  });
}
